import React, { useState, useEffect } from "react";
import {
  FeelingOptionsContainer,
  FeelingQuestion,
  NextButton,
  ModalFooter,
  StepTwoFew,
} from "./FeelingOptions.styled";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  FormGroup,
} from "@material-ui/core";
import { ReactComponent as NextIcon } from "../../../assets/svg/next-button-icon.svg";
import { ReactComponent as SaveButton } from "../../../assets/svg/save-button-icon.svg";
import { theme as themeConfig } from "../../../themes/themes";

const FeelingOptions = ({
  title,
  options,
  handleOption,
  faceSelect,
  backTOParent,
  optionsDetails,
  handleOptionDetails,
  detailTitle,
  selectedReason,
  selectedDetailedReason,
  setCheckMailingWellness,
  setCheckMailingSupervisor,
  handleNext,
  updateStepper,
  checkMailingWellness,
  checkMailingSupervisor,
  superVisorId,
  isSaving,
}) => {
  const [feelingReason, setFeelingReason] = useState();
  const [detailedReason, setDetailedReason] = useState([]);
  const [step, setStep] = useState(1);

  const handleChange = (event, value) => {
    const option = options.find((e) => e.id == parseInt(value));
    setFeelingReason(option);
    setDetailedReason([]);
  };

  const handleChangeDetails = (event) => {
    updateStepper(3);
    let detailedReasonID = parseInt(event.target.value);
    let detailedReasonArr = [...detailedReason];
    let index = detailedReasonArr.indexOf(detailedReasonID);
    if (index > -1) {
      detailedReasonArr.splice(index, 1);
    } else {
      detailedReasonArr.push(detailedReasonID);
    }
    setDetailedReason(detailedReasonArr);
  };

  const handleNextStep = () => {
    if (step === 1) {
      handleOption(parseInt(feelingReason?.id));
      if (faceSelect.triggerRequest) {
        setStep(2);
      } else {
        handleNext(parseInt(feelingReason?.id));
      }
    } else if (step === 2) {
      handleOptionDetails(detailedReason);
    }
  };

  const handleBack = () => {
    if (step === 2) {
      setStep(1);
      updateStepper(2);
      setDetailedReason([]);
    } else if (step === 1) {
      backTOParent();
    }
  };

  useEffect(() => {
    if (selectedReason && options.length > 0) {
      const reasonOption = options.find((opt) => opt.id === selectedReason);
      if (reasonOption) {
        setFeelingReason(reasonOption);
      }
    }
  }, [selectedReason, options]);

  useEffect(() => {
    if (optionsDetails.length > 0 && selectedDetailedReason.length > 0) {
      setDetailedReason([...selectedDetailedReason]);
    }
  }, [optionsDetails]);

  const getDetailedReasonCheck = (id) => {
    if (detailedReason.length > 0) {
      return detailedReason.includes(id);
    } else {
      return false;
    }
  };

  useEffect(() => {
    handleOptionDetails(detailedReason);
  }, [detailedReason]);

  const areFewCheckboxes = optionsDetails?.length <= 2;
  return (
    <>
      <FeelingOptionsContainer>
        <div style={{ display: "relative" }} className="FeelingOptionsHeader">
          <ArrowBackIosNewIcon
            style={{
              cursor: "pointer",
              position: "absolute",
              top: "29px",
              margin: "0",
              padding: "5px",
              marginLeft: '10px',
            }}
            onClick={() => {
              handleBack();
            }}
          />
          <h6 style={{ padding: "0 9%", textAlign: "center" }}>{title}</h6>
        </div>
        <FeelingQuestion
          len={step === 1 ? options?.length : optionsDetails?.length}
          isInitialStep={step === 1}
        >
          {step === 1 && (
            <div className="flex-div left-container">
              {faceSelect && faceSelect.icon && faceSelect.icon}
              {faceSelect && faceSelect.smileyFeel && (
                <label>
                  {faceSelect.smileyFeel}
                </label>
              )}
            </div>
          )}
          {step === 2 && (
            <StepTwoFew
              applyCustomStyle={areFewCheckboxes}
              className={!areFewCheckboxes ? "step-2" : null}
            >
              <span className="smiley-icon-few">
                {faceSelect && faceSelect.icon && faceSelect.icon}
              </span>
              {faceSelect && faceSelect.smileyFeel && (
                <label style={{ fontWeight: 400, padding: "0" }}>
                  {faceSelect.smileyFeel}
                </label>
              )}
            </StepTwoFew>
          )}
          <div className={`flex-div right-container steps-${step}`}>
            {step === 1 && (
              <RadioGroup
                name="feeling-reason"
                value={feelingReason?.id?.toString() ?? ''}
                onChange={handleChange}
              >
                {options.map((opt) => {
                  return (
                    <FormControlLabel
                      key={opt.id}
                      value={"" + opt.id}
                      control={
                        <Radio
                          style={{ padding: "5px" }}
                          checked={opt.id === parseInt(feelingReason?.id)}
                        />
                      }
                      label={
                        <span style={{ fontSize: "14px", color: themeConfig.text.primary }}>
                          {opt.description}
                        </span>
                      }
                    />
                  );
                })}
              </RadioGroup>
            )}
            {step === 2 && (
              <FormGroup>
                {optionsDetails.map((opt) => {
                  return (
                    <FormControlLabel
                      control={
                        <Checkbox
                          style={{ padding: "0 10px 0px" }}
                          checked={getDetailedReasonCheck(opt.id)}
                          value={opt.id}
                          onChange={handleChangeDetails}
                          name={opt.description}
                        />
                      }
                      label={
                        <span style={{ fontSize: "12px", color: themeConfig.text.primary }}>
                          {opt.description}
                        </span>
                      }
                      key={opt.id}
                    />
                  );
                })}
              </FormGroup>
            )}
            {step === 2 && (
              <FormGroup style={{ color: "black", paddingBottom: "10px" }}>
                <FormControlLabel
                  className="contact-check"
                  control={
                    <Checkbox
                      style={{ padding: "0 10px 20px" }}
                      disabled={checkMailingSupervisor}
                      onChange={(e) =>
                        setCheckMailingWellness(e.target.checked)
                      }
                      name="contact-check"
                    />
                  }
                  label={
                    <span style={{ fontSize: "14px", fontWeight: "500" }}>
                      {"I would like to be contacted by my wellness team."}
                    </span>
                  }
                />
              </FormGroup>
            )}
            {step === 2 && superVisorId && (
              <FormGroup style={{ color: "black", paddingBottom: "10px" }}>
                <FormControlLabel
                  className="contact-check"
                  control={
                    <Checkbox
                      style={{ padding: "0 10px 20px" }}
                      disabled={checkMailingWellness}
                      onChange={(e) =>
                        setCheckMailingSupervisor(e.target.checked)
                      }
                      name="contact-check"
                    />
                  }
                  label={
                    <span style={{ fontSize: "14px", fontWeight: "500" }}>
                      {"I would like to be contacted by my supervisor."}
                    </span>
                  }
                />
              </FormGroup>
            )}
          </div>
        </FeelingQuestion>
      </FeelingOptionsContainer>
      <ModalFooter className="felling-faces_btnnext">
        <div
          {...(step === 2 && {
            style: {
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              padding: "0 0 10px 13px",
            },
          })}
        >
          {step === 1 && (
            <NextButton
              style={{ marginBottom: "1.3em" }}
              onClick={() => handleNextStep()}
              disabled={step === 1 && !feelingReason}
            >
              <NextIcon className="next-button-icon" />
            </NextButton>
          )}
          {step === 2 && (
            <NextButton
              onClick={() => {
                handleNext(parseInt(feelingReason?.id));
              }}
              disabled={isSaving}
              style={{ marginBottom: "0.5em" }}
            >
              <SaveButton className="next-button-icon" />
            </NextButton>
          )}
        </div>
      </ModalFooter>
    </>
  );
};

export default FeelingOptions;
